import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const submitContact = async (formData) => {
  const response = await axios.post(`${API}/contact`, formData);
  return response.data;
};
